import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from './Constants';
import RequestHelper from './RequestHelper';
export var getTermsAndConditions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sessionId, affId) {
    var endpoint, headers, termsAndConditionsResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpoint = affId ? "".concat(Endpoints.TERMS_AND_CONDITIONS, "?aff_id=").concat(affId) : Endpoints.TERMS_AND_CONDITIONS;
            headers = {};
            if (sessionId) headers.Authentication = sessionId;
            _context.next = 5;
            return RequestHelper.apiGet({
              endpoint: endpoint,
              headers: headers
            });

          case 5:
            termsAndConditionsResponse = _context.sent;
            return _context.abrupt("return", termsAndConditionsResponse);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTermsAndConditions(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();